export const baseUrl= 'https://www.dnb.com';
export const enterpriseURL= 'https://www.dnb.com/en-us/smb.html';
export const publicSectorURL= 'https://www.dnb.com/en-us/public-sector.html';
export const dunsNumberURL= 'https://www.dnb.com/en-us/smb/duns.html';
export const serviceCenterURL= 'https://service.dnb.com/home';
export const globeHeaderIconURL= 'https://www.dnb.com/en-us/about/choose-your-country.html';
export const dunsNumberMythsURL= 'https://www.dnb.com/en-us/smb/duns/duns-number-myths.html';
export const businessCreditURL= 'https://www.dnb.com/en-us/products/dnb-credit-insights.html';
export const businessGrowthURL= 'https://www.dnb.com/en-us/products/web-solutions.html';
export const businessRiskURL= 'https://www.dnb.com/en-us/products/dnb-business-information-report.html';
export const resourcesHeaderURL= 'https://www.dnb.com/en-us/smb/blog/3-ways-start-rebuilding-companys-db-business-credit-scores-ratings.html';
export const allowedDomains = ['www-devaka.dnb.com', 'www-qaaka.dnb.com', 'www-stgaka.dnb.com', 'www.dnb.com'];
export const ukDunsNumberUrl = 'https://www.dnb.co.uk';